import React from 'react';
import Select from 'react-select'

import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import { Tabs, Tab } from 'material-ui/Tabs';

import Box from '../ui/Box';
import * as ENV from '../../environment/environment';


import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper

var KiotSpinner = null;

export default class NewCustomer extends React.Component {

  constructor() {
    super();
    let x = new Date();
    x.setDate(new Date().getDate() + 2)
    this.state = {
      role:true,
      room_num: -1,
      ch_in_time: new Date(),
      ch_out_time: x,
      extend_ch_out_time: x,
      cust_name: "",
      all_rooms: [],
      spinner: null,
      cust_phone: "",
      cust_email: "",
      maxDate: new Date(),
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    };

    this.getAllRooms();

  }

  getAllRooms() {
    let user = ls.getUserDetails()
    if (user.hotel_id) {
      ds.getAllRooms(user.hotel_id,
        data => {
          if (data && data.length) {
            for (let i of data) {
              i.label = i.hotel_room_id ? i.hotel_room_id.name : '';
              i.value = i._id;
            }
          }
          this.setState({
            all_rooms: data,
          })
        }, error => {
          console.log(error);
        })
    }
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  handleChange = (e, index, value) => this.setState({ 'room_num': value });

  createCustomer(e) {
    e.preventDefault()
    let user = ls.getUserDetails()
    if (this.validated()) {
      this.setState({
        spinner: <KiotSpinner />
      })
      let x = new Date(this.state.ch_in_time);
      let room_id;
      for (let i of this.state.all_rooms) {
        if (i._id == this.state.room_num && i.hotel_room_id) {
          room_id = i.hotel_room_id._id;
        }
        if(i.hotel_id && i.hotel_id.show_checkin_link == false){
          this.setState({
            role : false
          })
        }
      }
      ds.postNewCheckin({
        "guestUserId": this.state.room_num,
        "guest_name": this.state.cust_name,
        "guest_phone": this.state.cust_phone,
        "guest_email": this.state.cust_email,
        "check_out_time": this.state.ch_out_time,
        "check_in_time": x.toISOString(),
        "room_id": room_id
      }, data => {

        // let dialog = {
        //     open: true,
        //     head: 'Success',
        //     body: "Check-in Done, link: " + ENV.BASE_URL +'#/login/'+ encodeURIComponent(data.guestUser) + "__" + data.password,
        //     actions: [
        //         <FlatButton
        //             label="Okay"
        //             primary
        //             onClick={this.closeDialog.bind(this)}
        //         />
        //     ]
        // }
        let base_url = ENV.BASE_URL_FOR_CHECKIN;
        if (ls.getPartner()) {
          base_url = "";
          let partner_details = ls.getPartnerDetails();
          if (partner_details && partner_details.hospitality_portal && partner_details.hospitality_portal.hosting_urls) {
            base_url = partner_details.hospitality_portal.hosting_urls[0];
          }
        }
        let dialog
        if(user && user.roles && user.roles.includes("hotel_admin")){
          dialog = {
            head: 'Access Link',
            body: <div><input id="access_linku" style={{ width: "100%", border: "none" }} value={`${base_url}/#/login/${encodeURIComponent(data.guestUser)}__${data.password}`} disabled /></div>,
            open: true,
            actions: [
  
              <CopyToClipboard text={`${base_url}/#/login/${encodeURIComponent(data.guestUser)}__${data.password}`}
                onCopy={() => {
                  this.closeDialog();
                }}>
                <FlatButton
                  label="Copy"
                  primary
                />
              </CopyToClipboard>,
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
        }
        else if(user && user.roles && !user.roles.includes("hotel_admin")){

          if(this.state.role == false){
            dialog = {
              head: 'Success',
              body: 'Check in Successful',
              open: true,
              actions: [
              ]
            }
          }
          else{
            dialog = {
              head: 'Access Link',
              body: <div><input id="access_linku" style={{ width: "100%", border: "none" }} value={`${base_url}/#/login/${encodeURIComponent(data.guestUser)}__${data.password}`} disabled /></div>,
              open: true,
              actions: [
    
                <CopyToClipboard text={`${base_url}/#/login/${encodeURIComponent(data.guestUser)}__${data.password}`}
                  onCopy={() => {
                    this.closeDialog();
                  }}>
                  <FlatButton
                    label="Copy"
                    primary
                  />
                </CopyToClipboard>,
                <FlatButton
                  label="Okay"
                  primary
                  onClick={this.closeDialog.bind(this)}
                />
              ]
            }
          } 
        }
       
        this.setState({
          check_out_time: "",
          cust_name: "",
          cust_phone: "",
          cust_email:"",
          room_num: -1,
          dialog: dialog
        });
      }, err => {
        this.setState({
          spinner: null
        })
      })
    }
  }

  extendCheckout(e) {
    e.preventDefault()
    if (this.validated(1)) {
      this.setState({
        spinner: <KiotSpinner />
      })
      let room_id;
      for (let i of this.state.all_rooms) {
        if (i._id == this.state.room_num && i.hotel_room_id) {
          room_id = i.hotel_room_id._id;
        }
      }
      ds.postExtendCheckin({
        "_id": this.state.room_num,
        "check_out_time": this.state.extend_ch_out_time,
        "room_id": room_id
      }, data => {

        let dialog = {
          open: true,
          head: 'Success',
          body: "Check-in Extended",
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
        let x = new Date();
    x.setDate(new Date().getDate() + 2)
        this.setState({
         // extend_ch_out_time: x,
          cust_name: "",
          cust_phone: "",
          cust_email:"",
          room_num: -1,
          dialog: dialog
        });
      }, err => {
        this.setState({
          spinner: null
        })
      })

    }
  }

  validated(extend = 0) {
    let dialog;
    let flag = true;
    if (!this.state.room_num || this.state.room_num == -1) {

      dialog = {
        open: true,
        head: 'No Room Selected',
        body: "Select a room to check-in",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      flag = false;
    }
    // else if (this.state.ch_out_time < 0 || (!this.state.ch_out_time && this.state.ch_out_time != 0)) {
    //     // SmartMessageBox({
    //     //     title: "<i class='fa fa-exclamation-triangle' style='color:white'></i>Error",
    //     //     content: "Enter number of days",
    //     //     buttons: '[Ok]'
    //     // });
    //     dialog = {
    //         open: true,
    //         head: 'Invalid',
    //         body: "Enter number of days",
    //         actions: [
    //             <FlatButton
    //                 label="Okay"
    //                 primary
    //                 onClick={this.closeDialog.bind(this)}
    //             />
    //         ]
    //     }
    //     flag = false;
    // }
    else {
      if (!extend) { flag = this.validateDates(new Date(this.state.ch_in_time)).status; }
      let res = this.validateDates(new Date(this.state.ch_out_time))
      dialog = res.dialog;
      flag = res.status;
    }
    if (flag == false && dialog) {
      this.setState({
        dialog: dialog
      })
    }
    return flag;
  }

  validateDates(x) {
    try {
      if (!x || x == 'Invalid Date') {
        dialog = {
          open: true,
          head: 'Invalid Time',
          body: "Select a valid time",
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
        return { status: false, dialog };
      }
      else {
        return { status: true }
      }
    } catch (err) {
      console.log(err);
      dialog = {
        open: true,
        head: 'Invalid Time',
        body: "Select a valid time",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      return { status: false, dialog };
    }
  }

  render() {
    return (
      <Box header='Check-in'>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <Tabs className="tabs-container">
          <Tab label="New Check-in" className="tab">
            <div className="col-sm-12">
              <form className="smart-form " onSubmit={this.createCustomer.bind(this)}>
                <fieldset>
                  <section>
                    <TextField
                      floatingLabelText="Customer Name"
                      name="cust_name"
                      className="w-100"
                      value={this.state.cust_name}
                      onChange={this.handleChanges.bind(this)}
                    />
                  </section>

                  <section>
                    <TextField
                      floatingLabelText="Customer Phone #"
                      name="cust_phone"
                      className="w-100"
                      value={this.state.cust_phone}
                      onChange={this.handleChanges.bind(this)}
                    />
                  </section>

                  <section>
                    <TextField
                      floatingLabelText="Customer E-mail Address"
                      name="cust_email"
                      className="w-100"
                      value={this.state.cust_email}
                      onChange={this.handleChanges.bind(this)}
                    />
                  </section>

                  <section>

                    <Select
                      id="room_numid"
                      ref={(ref) => { this.select = ref; }}
                      onBlurResetsInput={false}
                      onSelectResetsInput={false}
                      autoFocus
                      options={this.state.all_rooms}
                      simpleValue
                      clearable={true}
                      name="room_num"
                      disabled={false}
                      value={this.state.room_num}
                      onChange={(newValue) => {
                        this.setState({
                          room_num: newValue,
                        })
                      }}
                      searchable={true}
                      placeholder="Room Number"
                      style={{ marginTop: "15px" }}
                    />
                  </section>

                  <section className="mt-1vw">
                    <div className="false-placeholder">Check-in Date & Time</div>

                    <DatePicker
                      hintText="Check-in Date"
                      container="inline"
                      name="ch_in_time"
                      className="col-sm-5 w-100"
                      maxDate={this.state.maxDate}
                      value={this.state.ch_in_time}
                      autoOk
                      style={{
                        maxWidth: '50%'
                      }}
                      onChange={(e, value) => {
                        this.setState({
                          ch_in_time: value
                        })
                      }} 
                    />

                    <TimePicker
                      format="ampm"
                      autoOk
                      hintText="Check-in Time"
                      className="col-sm-5 w-100"
                      value={this.state.ch_in_time}
                      onChange={(e, value) => {
                        this.setState({
                          ch_in_time: value
                        })
                      }}
                    />
                  </section>

                  <section className="mt-4vw">
                    <div className="false-placeholder">Check-out Date & Time</div>

                    <DatePicker
                      hintText="Check-out Date"
                      container="inline"
                      name="ch_out_time"
                      className="col-sm-5 w-100"
                      value={this.state.ch_out_time}
                      autoOk
                      style={{
                        maxWidth: '50%'
                      }}
                      onChange={(e, value) => {
                        this.setState({
                          ch_out_time: value
                        })
                      }} 
                    />

                    <TimePicker
                      format="ampm"
                      autoOk
                      hintText="Check-out Time"
                      className="col-sm-5 w-100"
                      value={this.state.ch_out_time}
                      onChange={(e, value) => {
                        this.setState({
                          ch_out_time: value
                        })
                      }}
                    />
                  </section>
                </fieldset>

                <div className="mt-4vw align-right">
                  <RaisedButton
                    label="Check-in"
                    primary
                    type="submit"
                  />
                </div>
              </form>
            </div>
          </Tab>

          <Tab label="Extend Check-in" className="tab">
            <div className="col-sm-12">
              <form className="smart-form " onSubmit={this.extendCheckout.bind(this)}>
                <fieldset>
                  <section>
                    <Select
                      id="room_numid"
                      ref={(ref) => { this.select = ref; }}
                      onBlurResetsInput={false}
                      onSelectResetsInput={false}
                      autoFocus
                      options={this.state.all_rooms}
                      simpleValue
                      clearable={true}
                      name="room_num"
                      disabled={false}
                      value={this.state.room_num}
                      onChange={(newValue) => {
                        this.setState({
                          room_num: newValue,
                        })
                      }}
                      searchable={true}
                      placeholder="Room Number"
                      style={{ marginBottom: "15px" }}
                    />
                  </section>

                  <section className="mt-1vw">
                    <div className="false-placeholder">New Check-out Date & Time</div>

                    <DatePicker
                      hintText="Check-out Date"
                      container="inline"
                      name="extend_ch_out_time"
                      className="col-sm-5 w-100"
                      value={this.state.extend_ch_out_time}
                      autoOk
                      style={{
                        maxWidth: '50%'
                      }}
                      onChange={(e, value) => {
                        this.setState({
                          extend_ch_out_time: value
                        })
                      }} 
                    />
                    
                    <TimePicker
                      format="ampm"
                      autoOk
                      hintText="Check-out Time"
                      className="col-sm-5 w-100"
                      value={this.state.extend_ch_out_time}
                      onChange={(e, value) => {
                        this.setState({
                          extend_ch_out_time: value
                        })
                      }}
                    />
                  </section>
                </fieldset>

                <div className="mt-4vw align-right">
                  <RaisedButton
                    label="Extend Stay"
                    primary
                    type="submit"
                  />
                </div>
              </form>
            </div>
          </Tab>
        </Tabs>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/customers/NewCustomer.js